import { render, staticRenderFns } from "./MassMessageStatItem.vue?vue&type=template&id=c2ae8382&scoped=true&"
import script from "./MassMessageStatItem.vue?vue&type=script&lang=ts&"
export * from "./MassMessageStatItem.vue?vue&type=script&lang=ts&"
import style0 from "./MassMessageStatItem.vue?vue&type=style&index=0&id=c2ae8382&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2ae8382",
  null
  
)

export default component.exports